import { Datagrid, List, TextField, EditButton, ShowButton, NumberField } from 'react-admin';

export const FailureCauseList = () => (
  <List sort={{ field: 'name', order: 'ASC' }} perPage={25}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <NumberField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);
